<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { visibilityObserver } from '@oat-sa-private/ui-core';
    import { breakpoints } from '@oat-sa-private/ui-identity';

    let { attributes = {}, children } = $props();

    let columnElement = $state(null);
    // For top and bottom scroll shadows:
    let fullyScrolledUp = $state(true);
    let fullyScrolledDown = $state(true);

    let windowWidth = $state(window.innerWidth);
</script>

<style>
    /*top and bottom shadows at the same time. Based on LDS mixins*/
    .bottom-shadow::after {
        content: '';
        height: 2rem;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: var(--layer-2);
        @add-mixin shadow-bottom-inset;
        pointer-events: none;
    }
    .top-shadow::before {
        content: '';
        height: 2rem;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: var(--layer-2);
        @add-mixin shadow-top-inset;
        pointer-events: none;
    }
    :global(.scrollable-container:focus-visible) {
        & .scrollable {
            outline: none;
            @add-mixin simple-outline;
        }
    }

    @media print {
        .bottom-shadow::after,
        .top-shadow::before {
            display: none;
        }
    }
</style>

{#if windowWidth && windowWidth <= breakpoints.width.medium}
    <div {...attributes}>
        {@render children?.()}
    </div>
{:else}
    <div {...attributes}>
        <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
        <div
            class="scrollable-container"
            class:bottom-shadow={!fullyScrolledDown}
            class:top-shadow={!fullyScrolledUp}
            bind:this={columnElement}
            tabindex="0">
            <div class="scrollable">
                <div
                    class="scroll-first-child"
                    use:visibilityObserver={columnElement || void 0}
                    onisVisible={e => (fullyScrolledUp = e.detail)}>
                </div>
                {@render children?.()}
                <div
                    class="scroll-last-child"
                    use:visibilityObserver={columnElement || void 0}
                    onisVisible={e => (fullyScrolledDown = e.detail)}>
                </div>
            </div>
        </div>
    </div>
{/if}
